<template>
  <div class="lattice">
    <div
      v-for="(item, i) in items"
      :key="`checkbox-grid-item-${i}`"
      :class="itemClasses(item)"
      @click="clickItem(item)"
    >
      <slot
        v-if="item.slotName"
        :name="item.slotName"
      />
      <template v-else>
        <div class="t bold w-100p ta-c">{{ item.text }}</div>
        <div class="fc-as">
          <i v-if="item.selected" class="mi purple">check_circle</i>
          <i v-else class="mi border">radio_button_unchecked</i>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    items: { type: Array, required: true },
  });

  const itemClasses = (item) => ({
      'card br-8 f-h f-ac f-jc p-x1 h-min-x12 f-gap-4 pressable': true,
      'purple-outline': item.selected,
      purple: item.filled,
    });

  const clickItem = (item) => {
    if (item.onClick) {
      item.onClick();
    } else {
      item.selected = !item.selected;
    }
  };
</script>
